import axios from 'axios';
import Symbol from 'es6-symbol/polyfill';
import EventEmitter from 'events';

let singleton = Symbol();
let singletonEnforcer = Symbol();

class AppControlService extends EventEmitter {
  //________________________________________________________ constructor
  // -
  constructor(pEnforcer) {
    if (pEnforcer !== singletonEnforcer) {
      throw 'Cannot construct singleton';
    }
    super();
    this._response = null;
    this._token = null;
    this._tokenAdmin = null;
    this._formPhotovoltaic = null;
    this._isSaved = false;
    this._isAdmin = true;
    this._datas = {};
    this._contacts = [];
    this._currentStep = 0;
    this.on('validating', (step) => {
      if (step === 0) this.goToNextStep();
    })
  }

  get id() {
    if(!this._response) return null;
    return this._response.id;
  }

  get number() {
    if(!this._response) return null;
    return this._response.number;
  }

  get token() {
    if(!this._token) return null;
    return this._token;
  }

  get tokenAdmin() {
    if(!this._tokenAdmin) return null;
    return this._tokenAdmin;
  }

  get isAdmin() {
    return this._isAdmin;
  }

  get saved() {
    return this._isSaved;
  }

  get datas() {
    return this._datas;
  }

  get contacts() {
    return this._contacts;
  }

  get currentStep() {
    return this._currentStep;
  }

  defineHasPhotovoltaic(form, hasPhotovoltaic) {
    this._formPhotovoltaic = hasPhotovoltaic ? form : null;
    this.emit('photovoltaic', this._formPhotovoltaic);
  }

  get formPhotovoltaic() {
    return this._formPhotovoltaic;
  }

  static getInstance() {
    if (!this[singleton]) {
      this[singleton] = new AppControlService(singletonEnforcer);
    }
    return this[singleton];
  }

  save() {
    const seq = axios.get(window.Routing.generate('api_soprasolar_save_claim_request', { token: this._token }));
    seq.then(() => {
      this._isSaved = true;
      this.emit('saved', this._isSaved);
    }).catch(console.error);
    return seq;
  }

  popinSaveToggle(open) {
    this.emit('popinSave', open);
  }

  popinHelpToggle(open, image) {
    this.emit('popinHelp', open, image);
  }

  getDatas(token) {
    const seq = axios.get(window.Routing.generate('api_soprasolar_get_claim_request', { token }));
    seq.then( res => {
      this._isSaved = true;
      this.emit('saved', this._isSaved);
      this._response = res.data;
      this._token = res.data.userToken;
      this._datas = res.data.data;
      this._contacts = res.data.contacts;
      this._isAdmin = res.data.isAdmin;
      if (this._isAdmin) this._tokenAdmin = token;
      this._whatIsStep();
      this.emit('datas', this._datas);
    }).catch(console.error);
    return seq;
  }

  update(step, datas) {
    return new Promise((resolve, reject) => {
      if( !this._datas[step] ) this._datas[step] = {};
      this._datas[step] = datas;
      let seq;
      if (this._datas.contacts) delete this._datas.contacts;
      if(this._token) {
        seq = axios.patch(window.Routing.generate('api_soprasolar_patch_claim_request', { token: this._token }), { ...this._datas });
      } else {
        seq = axios.post(window.Routing.generate('api_soprasolar_post_claim_request'), {...this._datas} );
      }
      seq.then( res => {
        this._response = res.data;
        this._token = res.data.userToken;
        this._datas = res.data.data;
        this._contacts = res.data.contacts;
        this.emit('datas', this._datas);
        resolve(datas);
      }).catch( (err) => {
        console.error(err);
        reject(err)
      });
    });
  }

  finish() {
    this._datas.finished = true;
    const seq = axios.patch(window.Routing.generate('api_soprasolar_patch_claim_request', { token: this._token }), { ...this._datas });
    seq.then( res => {
      this._response = res.data;
      this._datas = res.data.data;
      this.emit('datas', this._datas);
    })
    return seq;
  }

  download(token) {
    return axios.get(window.Routing.generate('api_soprasolar_download_excel', { token }), { responseType: 'blob' });
  }

  delete(step) {
    if (this._datas[step]) delete this._datas[step];
  }

  abortStep() {
    this.emit('aborted', this._currentStep);
  }

  validStep() {
    this.emit('validating', this._currentStep);
  }

  goTo(step) {
    this._currentStep = this._stepControl(step);
    this.emit('step', this._currentStep);
  }

  goToNextStep() {
    this._currentStep = this._stepControl(this._currentStep + 1);
    this.emit('step', this._currentStep);
  }

  goToPrevStep() {
    this._currentStep = this._stepControl(this._currentStep - 1);
    this.emit('step', this._currentStep);
  }

  _stepControl(step) {
    if(step < 0) step = 0;
    return step;
  }

  _whatIsStep() {
    const steps = [];
    let currentStep;
    if (!this._datas.finished) {
      for(let step in this._datas) {
        steps.push( parseInt(step.replace('step', '')) )
      }
      currentStep = steps.length;

      // TO DO
      currentStep = 2;
    } else currentStep = 'finished';
    this.goTo(currentStep);
  }
}
export default AppControlService.getInstance();